import { fetchHTML } from './utils-fetch-html.js';

class MainSearch extends HTMLElement {
  connectedCallback() {
    this.unsubscribeSortChanged = subscribe('sort:changed', () => this.handleSortChange());
    this.unsubscribeFiltersUpdated = subscribe('filters:updated', () => this.handleSortChange());
    this.unsubscribeMachineChange = subscribe('machine:change', (machineData) =>
      this.handleMachineChange(machineData)
    );
  }

  disconnectedCallback() {
    this.unsubscribeSortChanged?.();
    this.unsubscribeFiltersUpdated?.();
    this.unsubscribeMachineChange?.();
  }

  /**
   * Handle sort change.
   */
  async handleSortChange() {
    const searchParams = new URLSearchParams(window.location.search);

    try {
      const html = await fetchHTML(
        `${window.location.pathname}?section_id=main-search&${searchParams}`
      );

      this.renderProductGrid(html);
    } catch (error) {
      console.error(error);
      window.toast.error('Failed to update sort order');
    }
  }

  /**
   * Handle machine change.
   * @param {Object} machineData - The data related to the selected machine.
   */
  handleMachineChange(machineData) {
    const machineParam = 'filter.p.m.custom.models';
    const searchParams = new URLSearchParams(window.location.search);
    const previousUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;


    const skipMachineFilter = searchParams.get('skip_machine_filter');
    if (machineData?.modelGid && !skipMachineFilter) {
      searchParams.set(machineParam, machineData.modelGid);
    } else {
      searchParams.delete(machineParam);
    }

    const nextQuery = searchParams.toString();
    const nextUrl = `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ''}${
      window.location.hash
    }`;

    if (nextUrl === previousUrl) return;

    window.history.replaceState({}, '', nextUrl);
    this.handleSortChange();
  }

  /**
   * Render the product grid.
   * @param {HTMLElement} html - The HTML to render.
   */
  renderProductGrid(html) {
    const parsedMainSearch = html.querySelector('main-search');
    if (!parsedMainSearch) return;

    this.innerHTML = parsedMainSearch.innerHTML;
  }
}

customElements.define('main-search', MainSearch);
